import React from 'react';
import EventDetails from '../components/EventDetails';

const DetailsPage = () => {
  return (
    <div className="pt-5 mt-5">
      <EventDetails />
    </div>
  );
};

export default DetailsPage;